import React from "react";
import { useLocation } from "react-router-dom";
import SeoHelmet from "../components/SeoHelmet";
const SuccessPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paymentId = queryParams.get("payment_id");

  return (
    <>
     <SeoHelmet />
    <div className="success-page">
      <h1>Payment Successful!</h1>
      <p>Thank you for enrolling in the course.</p>
      <p>Your Payment ID: {paymentId}</p>
      <a href="/" className="btn btn-primary">Go Back to Home</a>
    </div>
    </>
   
  );
};

export default SuccessPage;
